import React from "react";

// OPTION 1 — "Global Powerhouse Emblem"
// A bold circular badge: solid navy medallion with a teal globe and a strong
// WWD monogram bar. Heavy, established, industrial-strength feel.
export default function LogoOption1({ variant = "dark", size = 52 }) {
  const navy = "#1b2545";
  const teal = "#2fb89c";
  const textMain = variant === "light" ? "#ffffff" : navy;

  return (
    <div className="flex items-center gap-3 select-none">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        <circle cx="32" cy="32" r="31" fill={navy} />
        <circle cx="32" cy="32" r="31" stroke={teal} strokeWidth="2" />
        {/* globe */}
        <circle cx="32" cy="27" r="13" stroke={teal} strokeWidth="2" fill="none" />
        <ellipse cx="32" cy="27" rx="5" ry="13" stroke={teal} strokeWidth="1.6" fill="none" />
        <line x1="19" y1="27" x2="45" y2="27" stroke={teal} strokeWidth="1.6" />
        {/* monogram bar */}
        <rect x="14" y="42" width="36" height="12" rx="3" fill={teal} />
        <text x="32" y="51" textAnchor="middle" fontFamily="Sora, sans-serif" fontWeight="800" fontSize="9" fill={navy} letterSpacing="1.5">WWD</text>
      </svg>
      <div className="leading-none">
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 800, fontSize: 18, color: textMain, letterSpacing: "0.5px", lineHeight: 1.05 }}>
          WORLD WIDE
        </div>
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 800, fontSize: 18, color: teal, letterSpacing: "0.5px", lineHeight: 1.05 }}>
          WHOLESALE DEALS
        </div>
        <div style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 9, color: variant === "light" ? "#9fb0c9" : "#8a94a8", letterSpacing: "4px", marginTop: 3 }}>
          L · L · C
        </div>
      </div>
    </div>
  );
}
